import { Path, useFormContext } from 'react-hook-form'

import { ContactFormDto } from '@/domains/contact/application/dto/createContact.dto'
import restrictToNumericInput from '@/utils/numericInputHandler'

type PhoneInputProps = {
  label: string
  tel: Path<ContactFormDto>
  indicator: Path<ContactFormDto>
  placeholder?: string
  errorMessage?: string
  className?: string
}

const countryOptions = [
  { code: '+33', label: 'FR' },
  { code: '+32', label: 'BE' },
  { code: '+49', label: 'GE' },
  { code: '+44', label: 'UK' },
  { code: '+39', label: 'IT' },
  { code: '+34', label: 'SP' },
  { code: '+31', label: 'NL' },
]

const PhoneInput = ({
  label,
  tel,
  indicator,
  placeholder,
  errorMessage,
  className,
}: PhoneInputProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<ContactFormDto>()

  const error = errors[tel]?.message as string | undefined

  return (
    <div className={`flex flex-col gap-1 ${className || ''}`}>
      <label htmlFor={tel} className="field-label">
        {label}
      </label>

      <div className="flex w-full items-stretch gap-4">
        <select
          id={indicator}
          {...register(indicator)}
          autoComplete="tel-country-code"
          aria-label="Code pays"
          className="field w-24 shrink-0 cursor-pointer appearance-none font-mono text-sm"
        >
          {countryOptions.map((option) => (
            <option key={option.code} value={option.code} className="bg-ink">
              {option.label} ({option.code})
            </option>
          ))}
        </select>

        <input
          id={tel}
          type="tel"
          autoComplete="tel-national"
          maxLength={14}
          {...register(tel, {
            required: errorMessage,
            minLength: { value: 5, message: 'Minimum 8 chiffres' },
            maxLength: { value: 14, message: 'Maximum 14 chiffres' },
          })}
          onKeyDown={restrictToNumericInput}
          placeholder={placeholder}
          aria-invalid={error ? true : undefined}
          className="field flex-1"
          required
        />
      </div>

      <div className="min-h-5 font-mono text-[0.6875rem] text-signal">
        {error}
      </div>
    </div>
  )
}

export default PhoneInput
